import type { PondScene } from '../pond/scene';

/** One preference shared by the pond, the art playground and Avatar Lab. */
export function createMotionControls(scene: PondScene): HTMLElement {
  const root = document.createElement('details');
  root.className = 'pond-settings motion-controls';
  const summary = document.createElement('summary');
  summary.textContent = 'Motion';
  const body = document.createElement('div');
  body.className = 'settings-popover';
  const label = document.createElement('label');
  label.textContent = 'Animation';
  const select = document.createElement('select');
  select.setAttribute('aria-label', 'Animation preference');
  for (const [value, text] of [['system', 'Use device setting'], ['reduce', 'Gentle motion'], ['full', 'Full motion']]) {
    select.append(new Option(text, value));
  }
  let preference = 'system';
  try { preference = localStorage.getItem('lilypad.motion') ?? 'system'; } catch { /* private browsing */ }
  select.value = ['system', 'reduce', 'full'].includes(preference) ? preference : 'system';
  const apply = () => scene.setReducedMotion(select.value === 'system' ? null : select.value === 'reduce');
  apply();
  select.addEventListener('change', () => {
    try { localStorage.setItem('lilypad.motion', select.value); } catch { /* private browsing */ }
    apply();
  });
  label.append(select);
  const pause = document.createElement('button');
  pause.type = 'button'; pause.className = 'btn secondary';
  pause.textContent = 'Pause pond'; pause.setAttribute('aria-pressed', 'false');
  pause.addEventListener('click', () => {
    scene.setPaused(!scene.isPaused);
    pause.textContent = scene.isPaused ? 'Resume pond' : 'Pause pond';
    pause.setAttribute('aria-pressed', String(scene.isPaused));
  });
  const note = document.createElement('p');
  note.className = 'muted'; note.textContent = 'Gentle motion keeps the pond still and navigation immediate.';
  body.append(label, pause, note); root.append(summary, body);
  return root;
}
